// Routes
export const STATUS_TRACKER_ERROR_ROUTE = '/statusTrackerError';

// GTM Events
export const GTM_STATUS_TRACKER_EVENTS = Object.freeze({
  START: 'START',
  ERROR: 'ERROR',
  DISABLED: 'DISABLED'
});



// WEBPACK FOOTER //
// ./src/constants/statusTracker.js